import School from '../../../api/School';
import * as types from './mutation-types';

export const show = async ({commit}, {id}) => {
    const json = await new School().show(id);

    commit(types.SCHOOL_FILL_INFO, json.data);
    commit(types.SCHOOL_FILL_COURSES, json.data.courses);
};

export const clear = ({commit}) => {
    commit(types.SCHOOL_CLEAR_INFO);
};

export const create = async ({commit}, {params}) => {
    const json = await new School().store(params);

    commit(types.ID, json.data.id);
    commit(types.CREATED_AT, json.data.created_at);
    //Temporary
    commit(types.COUNTRY, json.data.country);
    return json;
};

export const update = async ({}, {params}) => {
    return await new School().update(params.id, params);
};

export const destroy = async ({}, {id}) => {
    return await new School().destroy(id);
};

export const getAll = async ({commit}) => {
    const json = await new School().getAll();

    commit(types.LIST, json.data);
};

export default {
    show,
    clear,
    create,
    update,
    destroy,
    getAll,
};



// WEBPACK FOOTER //
// ./src/store/modules/school/actions.js